import { getConfig } from '../config/config';
import { toast } from 'react-toastify';

const logInfo = (info: unknown) => {
    if (getConfig().environment === 'local' || getConfig().environment === 'Dev') {
        const message = typeof info === 'string' ? `${getLogPrefix()}${info}` : info;
        console.log(message);
    }
};

const logWarning = (warning: unknown) => {
    const message = typeof warning === 'string' ? `${getLogPrefix()}${warning}` : warning;
    console.warn(message);
};

const logError = (error: unknown) => {
    const message = typeof error === 'string' ? `${getLogPrefix()}${error}` : error;
    console.error(message);
};

const reportUserError = (message: string, errorId: number | string) => {
    logError('Error: ' + message);
    if (!getConfig().isWidget) {
        toast.error(message, { toastId: errorId });
    }
};

const getLogPrefix = () => {
    const windowName = window === window.parent ? 'top' : window.frameElement && window.frameElement.id;
    return `${windowName || 'unknown frame'}: `;
};

export { logInfo, logWarning, logError, reportUserError };
